module.exports = __webpack_public_path__ + "static/media/navigation_flow_old.b807ff27.jpg";